var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.edit)?_c('workflowGrid',{on:{"editItem":_vm.editItem}}):_c('workflowbForm',{attrs:{"workflowName":_vm.workflowName},on:{"editItem":_vm.editItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }